import { Button, Card } from "antd";
import React, { useEffect, useState } from "react";
import Icon from "../assets/Icon";
import { verifyEmailApi } from "../api/common";
import Loader from "../components/Loader";
import { Link } from "react-router-dom";

const verifyToken = window.location.pathname.split("/").pop();
function MailVerified() {
  const [flag, setFlag] = useState(false);
  const [flagF, setFlagF] = useState(false);
  const [loading, setLoading] = useState(false);

  const getData = async () => {
    const url = `${verifyEmailApi}/${verifyToken}`;
    setLoading(true);
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await response.json();
      setLoading(false);
      if (result.resultStatusInfo.resultCode.toLowerCase() === "success") {
        setFlag(true);
      } else if (
        result.resultStatusInfo.resultCode === "INVALID_TOKEN" ||
        result.resultStatusInfo.resultCode.toLowerCase() === "notfound" ||
        result.resultStatusInfo.resultCode.toLowerCase() === "failure"
      ) {
        setFlagF(true);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    localStorage.clear();
    sessionStorage.clear();
    getData();
  }, []);

  return (
    <>
      {loading && <Loader />}
      <div className="h-screen flex flex-col">
        {/* Logo section */}
        <div className="px-5 py-4 sm:block flex justify-center bg-[#0F1B23]">
          <span className="flex  items-center">
            <Icon type="jobdrona-logo" width={50} height={32} />
            <span className="font-bold text-orangish text-[1.25rem]">
              JobDrona
            </span>
          </span>
        </div>
        {/* <div className="absolute inset-0 bg-[radial-gradient(circle,_rgba(156,163,175,0.3)_2px,_transparent_1px)] bg-[length:30px_30px] [mask-image:linear-gradient(135deg,rgba(0,0,0,1),rgba(0,0,0,0))] pointer-events-none"></div> */}

        {/* Remaining space */}
        {flag && (
          <div className="flex-1 flex flex-col items-center justify-center sm:w-[500px] w-full px-4  m-auto">
            <div className="flex justify-center">
              <svg
                width="170"
                height="154"
                viewBox="0 0 170 154"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask
                  id="mask0_514_3124"
                  // style="mask-type:luminance"
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="170"
                  height="154"
                >
                  <path d="M169.791 0H0.191406V153.6H169.791V0Z" fill="white" />
                </mask>
                <g mask="url(#mask0_514_3124)">
                  <mask
                    id="mask1_514_3124"
                    // style="mask-type:luminance"
                    maskUnits="userSpaceOnUse"
                    x="-46"
                    y="-23"
                    width="738"
                    height="826"
                  >
                    <path
                      d="M-45.8223 -22.8086H691.171V802.63H-45.8223V-22.8086Z"
                      fill="white"
                    />
                  </mask>
                  <g mask="url(#mask1_514_3124)">
                    <g opacity="0.5">
                      <path
                        d="M23.9424 76.4016L103.663 30.1543L23.9424 76.4016Z"
                        fill="white"
                      />
                      <path
                        d="M23.9424 76.4016L103.663 30.1543"
                        stroke="#E5E5E5"
                        stroke-width="22.0833"
                        stroke-linecap="round"
                      />
                    </g>
                    <g opacity="0.5">
                      <path
                        d="M42.9092 106.732L122.63 60.4844L42.9092 106.732Z"
                        fill="white"
                      />
                      <path
                        d="M42.9092 106.732L122.63 60.4844"
                        stroke="#E5E5E5"
                        stroke-width="22.0833"
                        stroke-linecap="round"
                      />
                    </g>
                    <g opacity="0.5">
                      <path
                        d="M143.041 48.8569L149.254 45.2051L143.041 48.8569Z"
                        fill="white"
                      />
                      <path
                        d="M143.041 48.8569L149.254 45.2051"
                        stroke="#E5E5E5"
                        stroke-width="22.0833"
                        stroke-linecap="round"
                      />
                    </g>
                    <g opacity="0.5">
                      <path
                        d="M71.0342 131.686L131.579 95.9805L71.0342 131.686Z"
                        fill="white"
                      />
                      <path
                        d="M71.0342 131.686L131.579 95.9805"
                        stroke="#E5E5E5"
                        stroke-width="22.0833"
                        stroke-linecap="round"
                      />
                    </g>
                    <path
                      d="M146.488 99.1565C147.455 99.2602 148.159 100.135 148.059 101.108C147.959 102.082 147.093 102.788 146.126 102.685C145.159 102.581 144.455 101.706 144.555 100.733C144.654 99.7592 145.521 99.0529 146.488 99.1565Z"
                      stroke="#00C83C"
                      stroke-width="1.02805"
                    />
                    <path
                      d="M43.6237 136.026C45.214 136.196 46.3719 137.634 46.2078 139.235C46.0437 140.836 44.6193 141.998 43.029 141.827C41.4387 141.657 40.2807 140.219 40.4448 138.618C40.6089 137.017 42.0334 135.855 43.6237 136.026Z"
                      stroke="#00C83C"
                      stroke-width="1.69056"
                    />
                    <path
                      d="M83.7213 15.592C85.3116 15.7625 86.4696 17.2007 86.3055 18.8016C86.1414 20.4026 84.7169 21.564 83.1266 21.3936C81.5363 21.2232 80.3784 19.7849 80.5425 18.184C80.7066 16.583 82.131 15.4216 83.7213 15.592Z"
                      stroke="#00C83C"
                      stroke-width="1.69056"
                    />
                    <path
                      d="M16.7607 53.7637C17.4931 53.7637 18.0878 54.3641 18.0878 55.1036C18.0878 55.8431 17.4931 56.4435 16.7607 56.4435C16.0283 56.4435 15.4336 55.8431 15.4336 55.1036C15.4336 54.3641 16.0283 53.7637 16.7607 53.7637Z"
                      stroke="#00C83C"
                      stroke-width="1.23573"
                    />
                    <path
                      d="M119.833 141.139C120.565 141.139 121.16 141.739 121.16 142.479C121.16 143.218 120.565 143.819 119.833 143.819C119.101 143.819 118.506 143.218 118.506 142.479C118.506 141.739 119.101 141.139 119.833 141.139Z"
                      stroke="#4D5762"
                      stroke-width="1.23573"
                    />
                    <path
                      d="M135.282 15.2227L136.164 9.91874"
                      stroke="#4D5762"
                      stroke-width="0.72"
                    />
                    <path
                      d="M133.188 12.1523L138.441 13.0427"
                      stroke="#4D5762"
                      stroke-width="0.72"
                    />
                    <path
                      d="M22.4785 103.014L23.1356 97.6759"
                      stroke="#4D5762"
                      stroke-width="0.72"
                    />
                    <path
                      d="M20.2559 100.035L25.5414 100.698"
                      stroke="#4D5762"
                      stroke-width="0.72"
                    />
                    <path
                      d="M133.252 126.262L133.538 120.89"
                      stroke="#4D5762"
                      stroke-width="0.72"
                    />
                    <path
                      d="M130.818 123.449L136.137 123.738"
                      stroke="#4D5762"
                      stroke-width="0.72"
                    />
                  </g>
                  <path
                    d="M85.0163 38.1406C106.153 38.1406 123.315 55.4682 123.315 76.8096C123.315 98.151 106.153 115.479 85.0163 115.479C63.8794 115.479 46.7178 98.151 46.7178 76.8096C46.7178 55.4682 63.8794 38.1406 85.0163 38.1406Z"
                    fill="#404040"
                  />
                  <path
                    d="M84.9927 41.7949C104.131 41.7949 119.669 57.4837 119.669 76.8066C119.669 96.1296 104.131 111.818 84.9927 111.818C65.8549 111.818 50.3164 96.1296 50.3164 76.8066C50.3164 57.4837 65.8549 41.7949 84.9927 41.7949Z"
                    fill="white"
                  />
                  <path
                    d="M69.3389 78.0951L78.7137 87.3455L100.659 65.1875"
                    stroke="#07B83C"
                    stroke-width="4.32"
                  />
                </g>
              </svg>
            </div>
            <div className="text-[#101828] text-3xl font-semibold mt-2 text-center">
              Email Verified Successfully!
            </div>
            <div className="text-[#475467] mt-2 text-center">
              Your email is confirmed. You can now access all features.
            </div>

            <div className="mt-3">
              <Link to="/login">
                <button className={`bg-orangish py-2 px-4  rounded-md`}>
                  back to Login
                </button>
              </Link>
            </div>
          </div>
        )}

        {flagF && (
          <div className="flex-1 flex flex-col items-center justify-center sm:w-[500px] w-full px-4  m-auto">
            <div className="flex justify-center">
              <svg
                width="186"
                height="160"
                viewBox="0 0 186 160"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M160.751 89.3553C157.305 57.846 129.745 28.6437 99.5393 15.1698C57.536 -3.59384 17.6781 -2.03415 5.34416 35.0687C-6.56573 70.9774 15.3418 85.9118 61.2048 103.866C105.092 121.042 164.954 127.773 160.751 89.3553Z"
                  fill="#EDC043"
                />
                <path
                  opacity="0.9"
                  d="M160.751 89.3553C157.305 57.846 129.745 28.6437 99.5393 15.1698C57.536 -3.59384 17.6781 -2.03415 5.34416 35.0687C-6.56573 70.9774 15.3418 85.9118 61.2048 103.866C105.092 121.042 164.954 127.773 160.751 89.3553Z"
                  fill="white"
                />
                <path
                  d="M181.555 89.2159L181.038 89.2656L181.711 96.2648L182.228 96.2151L181.555 89.2159Z"
                  fill="#EDC043"
                />
                <path
                  d="M182.474 98.6515L181.957 98.7012L182.228 101.526L182.745 101.476L182.474 98.6515Z"
                  fill="#EDC043"
                />
                <path
                  d="M57.6629 159.273L185.292 147.006L177.989 71.0274L50.3604 83.2942L57.6629 159.273Z"
                  fill="#EDC043"
                />
                <path
                  opacity="0.1"
                  d="M57.6629 159.273L185.292 147.006L177.989 71.0274L50.3604 83.2942L57.6629 159.273Z"
                  fill="black"
                />
                <path
                  opacity="0.1"
                  d="M118.16 118.603L50.3608 83.2929L177.987 71.0234L118.16 118.603Z"
                  fill="#263238"
                />
                <path
                  d="M102.714 41.662L50.3608 83.2928L177.987 71.0234L118.663 40.131C116.141 38.8171 113.292 38.2624 110.462 38.5341C107.631 38.8058 104.94 39.8923 102.714 41.662Z"
                  fill="#EDC043"
                />
                <path
                  opacity="0.2"
                  d="M173.247 71.4814L116.881 42.1255C114.979 41.1338 112.83 40.715 110.695 40.9198C108.56 41.1246 106.531 41.9441 104.852 43.2792L55.0962 82.8323L173.247 71.4814Z"
                  fill="#263238"
                />
                <path
                  d="M149.676 70.5469L166.948 75.1616L167.364 79.4701L118.16 118.602L62.4009 89.5634L61.5698 80.9464L149.676 70.5469Z"
                  fill="white"
                />
                <path
                  d="M149.676 70.5469L152.94 79.5904L166.949 75.1616"
                  fill="#E0E0E0"
                />
                <path
                  d="M149.676 70.5469L151.355 78.0048L166.949 75.1616"
                  fill="#F0F0F0"
                />
                <path
                  d="M128.357 110.479L185.292 147.008L57.6655 159.272L106.596 112.567C109.464 109.831 113.169 108.137 117.115 107.759C121.061 107.38 125.02 108.338 128.357 110.479Z"
                  fill="#EDC043"
                />
                <g clip-path="url(#clip0_514_2807)">
                  <path
                    d="M123.112 98.9392C123.112 98.9392 119.885 95.7222 115.375 96.3733C110.866 97.0244 108.681 101.023 108.681 101.023M119.485 86.5727L119.503 86.5701M108.662 88.1354L108.68 88.1328M100.214 118.897L84.7798 139.54L64.1368 124.106L79.5707 103.463L100.214 118.897ZM120.387 86.4425C120.459 86.9406 120.113 87.4027 119.615 87.4746C119.117 87.5465 118.655 87.201 118.583 86.7029C118.511 86.2048 118.856 85.7427 119.355 85.6708C119.853 85.5988 120.315 85.9443 120.387 86.4425ZM109.564 88.0052C109.635 88.5033 109.29 88.9654 108.792 89.0373C108.294 89.1092 107.832 88.7637 107.76 88.2656C107.688 87.7675 108.033 87.3054 108.531 87.2335C109.03 87.1616 109.492 87.5071 109.564 88.0052Z"
                    stroke="black"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_514_2807">
                    <rect
                      width="43.7413"
                      height="43.7413"
                      fill="white"
                      transform="translate(93.0093 71.2207) rotate(-8.21601)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div className="text-[#101828] text-3xl font-semibold mt-2 text-center">
              Oops! Link Expired / Invalid Token
            </div>
            <div className="text-[#475467] mt-2 text-center">
              Your link has expired or token is invalid.
            </div>

            <div className="mt-3">
              <Link to="/login">
                <button className={`bg-orangish py-2 px-4  rounded-md`}>
                  back to Login
                </button>
              </Link>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default MailVerified;
